var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import client from "../../http/client";
import { Dialog, Form } from "radix-ui";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RadixDialogue } from "../primitives/RadixDialogue";
import { RadixFlyOut } from "../primitives/RadixFlyOut";
import { RadixInput } from "../primitives/RadixInput";
import { RadixButton } from "../primitives/RadixButton";
import { useDebouncedValidation } from "../utility/useDebouncedValidation";
import { useAuth, useCart, useOrderIntent, useUI } from "../../providers";
import { userSignInModalSchema } from "./userSignInModalSchema";
import { UserSignup } from "../userSignup";
import "../ui.css";
import "../userSignInModal/userSignInModal.css";
import { RadixCheckbox } from "../primitives/RadixCheckbox";
import GoogleAnalytics from "../../analytics/google";
export var UserSignInModal = function () {
    var _a = useUI(), signInModalIsOpen = _a.signInModalIsOpen, setSignInModalIsOpen = _a.setSignInModalIsOpen, showToast = _a.showToast, authModalView = _a.authModalView, setAuthModalView = _a.setAuthModalView;
    var handleLogin = useAuth().handleLogin;
    var getCart = useCart().getCart;
    var _b = useOrderIntent(), currentAddress = _b.currentAddress, setCurrentAddress = _b.setCurrentAddress;
    var _c = useState(false), rememberMe = _c[0], setRememberMe = _c[1];
    var _d = useState(false), loggingIn = _d[0], setLoggingIn = _d[1];
    var _e = useState(false), showLoginError = _e[0], setShowLoginError = _e[1];
    var _f = useState(false), forgotPasswordMode = _f[0], setForgotPasswordMode = _f[1];
    var _g = useState(false), resettingPassword = _g[0], setResettingPassword = _g[1];
    var _h = useState(false), isPasswordVisible = _h[0], setIsPasswordVisible = _h[1];
    var _j = useState(false), signupFlyOutIsOpen = _j[0], setSignupFlyOutIsOpen = _j[1];
    var _k = useForm({
        resolver: zodResolver(userSignInModalSchema),
        mode: "onBlur",
        defaultValues: {
            email: "",
            password: "",
        },
    }), control = _k.control, handleSubmit = _k.handleSubmit, trigger = _k.trigger, _l = _k.formState, errors = _l.errors, isValid = _l.isValid, getValues = _k.getValues, setValue = _k.setValue;
    useEffect(function () {
        var rememberedEmail = String(localStorage.getItem("remembered_signin_email") || "").trim();
        if (!rememberedEmail) {
            return;
        }
        setValue("email", rememberedEmail, { shouldValidate: true });
        setRememberMe(true);
    }, [setValue]);
    var debouncedTrigger = useDebouncedValidation(trigger);
    var handleValidSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var loginResponse, _error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setShowLoginError(false);
                    setLoggingIn(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, handleLogin({
                            email: data.email,
                            password: (_a = data.password) !== null && _a !== void 0 ? _a : "",
                            rememberMe: rememberMe,
                            checkoutAddressId: (_b = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id) !== null && _b !== void 0 ? _b : null,
                        })];
                case 2:
                    loginResponse = _c.sent();
                    if (loginResponse.checkout_address) {
                        setCurrentAddress(loginResponse.checkout_address);
                    }
                    return [4 /*yield*/, getCart()];
                case 3:
                    _c.sent();
                    if (rememberMe) {
                        localStorage.setItem("remembered_signin_email", data.email.trim());
                    }
                    else {
                        localStorage.removeItem("remembered_signin_email");
                    }
                    GoogleAnalytics.userLogin();
                    setSignInModalIsOpen(false);
                    showToast("Successfully signed in.", "success");
                    return [3 /*break*/, 6];
                case 4:
                    _error_1 = _c.sent();
                    setShowLoginError(true);
                    return [3 /*break*/, 6];
                case 5:
                    setLoggingIn(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (authModalView !== "signup" || !signInModalIsOpen) {
            return;
        }
        setSignInModalIsOpen(false);
        setSignupFlyOutIsOpen(true);
        setAuthModalView("signin");
    }, [authModalView, signInModalIsOpen, setAuthModalView, setSignInModalIsOpen]);
    var handleResetPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var emailIsValid, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, trigger("email")];
                case 1:
                    emailIsValid = _d.sent();
                    if (!emailIsValid) {
                        return [2 /*return*/];
                    }
                    setResettingPassword(true);
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, 5, 6]);
                    return [4 /*yield*/, client.post("/forgot-password", {
                            email: getValues("email"),
                        })];
                case 3:
                    _d.sent();
                    showToast("If an account exists with that email, you will receive a password reset link shortly.", "success");
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _d.sent();
                    showToast((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "Unable to reset password.", "error");
                    return [3 /*break*/, 6];
                case 5:
                    setResettingPassword(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(RadixDialogue, { open: signInModalIsOpen, onOpenChange: function (isOpen) {
                setSignInModalIsOpen(isOpen);
                if (!isOpen) {
                    setAuthModalView("signin");
                    setForgotPasswordMode(false);
                    setShowLoginError(false);
                }
            }, overlayClassName: "radix-modal-overlay", contentClassName: "radix-modal-content user-sign-in-modal-content" },
            React.createElement("header", { className: "radix-flyout-header user-sign-in-modal-header" },
                React.createElement(Dialog.Title, { className: "radix-modal-title user-sign-in-modal-title" }, "Sign in"),
                React.createElement(Dialog.Close, { className: "radix-flyout-close user-sign-in-modal-close", "aria-label": "Close user sign-in dialogue." },
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
            React.createElement("div", { className: "radix-modal-body" },
                React.createElement(Form.Root, { onSubmit: handleSubmit(handleValidSubmit), className: "radix-form", noValidate: true },
                    React.createElement("div", { className: "radix-form-field" },
                        React.createElement(Controller, { name: "email", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RadixInput, { label: "Email", id: "user-signin-email", name: "email", type: "email", autoComplete: "email", placeholder: "Email", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (event) {
                                        field.onChange(event.target.value);
                                        debouncedTrigger("email");
                                    }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.email, "aria-describedby": errors.email ? "user-signin-email-error" : undefined }));
                            } }),
                        errors.email ? (React.createElement("span", { id: "user-signin-email-error", className: "radix-error-message" },
                            React.createElement("i", { className: "fas fa-exclamation-circle" }),
                            " ",
                            errors.email.message)) : null),
                    !forgotPasswordMode ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "radix-form-field" },
                            React.createElement(Controller, { name: "password", control: control, render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (React.createElement(RadixInput, { label: "Password", id: "user-signin-password", name: "password", type: isPasswordVisible ? "text" : "password", autoComplete: "current-password", placeholder: "Password", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (event) {
                                            field.onChange(event.target.value);
                                            debouncedTrigger("password");
                                        }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.password, "aria-describedby": errors.password ? "user-signin-password-error" : undefined, rightElement: (React.createElement("button", { type: "button", className: "radix-input-icon-button", onClick: function () { return setIsPasswordVisible(function (currentValue) { return !currentValue; }); }, "aria-label": isPasswordVisible ? "Hide password" : "Show password" },
                                            React.createElement("i", { className: "fas ".concat(isPasswordVisible ? "fa-eye-slash" : "fa-eye") }))) }));
                                } }),
                            errors.password ? (React.createElement("span", { id: "user-signin-password-error", className: "radix-error-message" },
                                React.createElement("i", { className: "fas fa-exclamation-circle" }),
                                " ",
                                errors.password.message)) : null),
                        React.createElement("div", null,
                            React.createElement(RadixCheckbox, { id: "user-signin-remember-me", checked: rememberMe, onCheckedChange: setRememberMe, label: "Remember me" })))) : null,
                    showLoginError ? (React.createElement("span", { className: "radix-error-message", role: "status" },
                        React.createElement("i", { className: "fas fa-exclamation-circle" }),
                        " That didn\u2019t work\u2014check your info and give it another shot.")) : null,
                    forgotPasswordMode ? (React.createElement("button", { type: "button", className: "radix-submit-button", onClick: handleResetPassword, disabled: resettingPassword }, "Reset Password")) : (React.createElement(RadixButton, { type: "submit", disabled: !isValid || loggingIn, className: "radix-submit-button", "aria-busy": loggingIn }, loggingIn ? (React.createElement("span", { className: "radix-sign-in-loading-indicator", role: "status", "aria-live": "polite" },
                        React.createElement("span", { className: "radix-sign-in-loading-spinner", "aria-hidden": "true" }),
                        "Signing in...")) : "Sign in")),
                    React.createElement("button", { type: "button", className: "radix-sign-in-forgot-link radix-sign-in-text-button", onClick: function () { return setForgotPasswordMode(function (current) { return !current; }); }, disabled: loggingIn }, forgotPasswordMode ? "Sign in instead" : "Forgot password?"),
                    React.createElement("button", { type: "button", className: "radix-sign-in-forgot-link radix-sign-in-text-button", onClick: function () {
                            setForgotPasswordMode(false);
                            setShowLoginError(false);
                            setAuthModalView("signup");
                        }, disabled: loggingIn || resettingPassword }, "Need an account? Create one.")))),
        React.createElement(RadixFlyOut, { open: signupFlyOutIsOpen, onOpenChange: setSignupFlyOutIsOpen, title: "Create account", closeLabel: "Close create account panel." },
            React.createElement(UserSignup, { embedded: true, onSuccess: function () {
                    setSignupFlyOutIsOpen(false);
                }, onSwitchToSignIn: function () {
                    setSignupFlyOutIsOpen(false);
                    setForgotPasswordMode(false);
                    setShowLoginError(false);
                    setSignInModalIsOpen(true);
                    setAuthModalView("signin");
                } }))));
};
